import { render } from "./MenuTableBackground.vue?vue&type=template&id=30524ffe&scoped=true"
import script from "./MenuTableBackground.vue?vue&type=script&lang=js"
export * from "./MenuTableBackground.vue?vue&type=script&lang=js"

import "./MenuTableBackground.vue?vue&type=style&index=0&id=30524ffe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30524ffe"]])

export default __exports__